/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

(function() {
    var touchingCarousel = false,
      touchStartCoords;

    document.body.addEventListener('touchstart', function(e) {
      if (e.target.closest('.flickity-slider')) {
        touchingCarousel = true;
      } else {
        touchingCarousel = false;
        return;
      }

      touchStartCoords = {
        x: e.touches[0].pageX,
        y: e.touches[0].pageY
      }
    });

    document.body.addEventListener('touchmove', function(e) {
      if (!(touchingCarousel && e.cancelable)) {
        return;
      }

      var moveVector = {
        x: e.touches[0].pageX - touchStartCoords.x,
        y: e.touches[0].pageY - touchStartCoords.y
      };

      if (Math.abs(moveVector.x) > 7)
        e.preventDefault()

    }, {passive: false});
  })();

// GEO REDIRECT
  $(document).ready(function(){
    if (typeof(Storage) !== "undefined") {
  // AJAX request once in session
  var country_code = sessionStorage.getItem("country_code");
  if (country_code === null) {
    jQuery.ajax({
    url: 'https://get.geojs.io/v1/ip/geo.json',
    type: 'GET',
    dataType: 'json',
    success: function(location) {
      sessionStorage.setItem("country_code", location.country_code);
      openModal(location.country_code);
    }
    });
  } else if(sessionStorage.geoipModalShown !== 'shown') {
      openModal(country_code);
  }
}

  function openModal(country_code) {
  // GEOIP MODAL
  //var modalSelector = '#geoipModal';
    var modalSelector = $('[id*="' + 'geoipModal' + '"]');
  var shop_country_code = $('[data-shop-country-code]').data('shopCountryCode');
   console.log($(modalSelector).length);
  //FI store check
  console.log("country_code: " + country_code + " and shop_country_code: " + shop_country_code);
  if(country_code == "FI"){
    sessionStorage.geoipModalShown = 'shown';
    console.log("User is from Finland, no need to display popup.")
  }
  else if(!$(modalSelector).length){
      console.log("modal not active");
  }
  else{
      $('.jquery-modal').css("display","block");
      sessionStorage.geoipModalShown = 'shown';
  } 
  }
  $('.close-modal').click(function(){
        sessionStorage.geoipModalShown = 'shown';
         $('.jquery-modal').css("display","none");
         });
    
});